export default {
    props: {
        assignmentsDataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'assignments.dataSource'
        }, 
        assignmentsDataResourceIdField: {
            type: String,
            default: undefined,
            kComposite: 'assignments.dataResourceIdField'
        }, 
        assignmentsDataTaskIdField: {
            type: String,
            default: undefined,
            kComposite: 'assignments.dataTaskIdField'
        }, 
        assignmentsDataValueField: {
            type: String,
            default: undefined,
            kComposite: 'assignments.dataValueField'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/Assignments.js